import React, { useEffect } from "react";

function useWatchFocus<T extends HTMLElement,>(
  ref: React.RefObject<T>,
  handler: (event: any) => void | (() => void) | null,
) {
  useEffect(() => {
    if (!handler) return;
    const listener = (event: FocusEvent) => {
      if (ref.current?.contains(document.activeElement)) {
        return;
      }
      handler(event)
    };
    document.addEventListener("focusin", listener);
    return () => {
      document.removeEventListener("focusin", listener);
    };
  },
    [ref, handler]
  );
}

export { useWatchFocus }

